import { A4Electricitymeter } from '@e3dc-react/icons'
import { Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Unit } from '../SystemSettingsUtils'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.grey.grey06,
    backgroundColor: 'white',
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    fontSize: '30px',
  },
  valueContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
}))

interface EnergyValuesProps {
  title: string
  value: number
  unit: Unit
}

const EnergyValues: React.FC<EnergyValuesProps> = ({ title, value, unit }) => {
  const { classes } = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.descriptionContainer}>
        <A4Electricitymeter className={classes.icon} />
        <Typography variant={'subtitle2'} marginLeft={1}>
          {title}
        </Typography>
      </div>

      <div className={classes.valueContainer}>
        <Typography variant={'h3'}>{getLocalizedNumber(value)}</Typography>
        <Typography variant={'body2'} marginLeft={1}>
          {unit}
        </Typography>
      </div>
    </div>
  )
}

export default EnergyValues
